<template>
  <div class="panel_shouyin">
    <div class="titleLine">
      <el-row>
        <el-col :span="3" :offset="21">
          <el-button @click="add" size="mini" style="margin-left: 20px"
            >购买洗美卡</el-button
          >
        </el-col>
      </el-row>
    </div>
    <div class="listLine">
      <el-table :data="tableData"  height="550" style="width: 100%">
        <el-table-column label="洗美卡名称" min-width="110">
          <template slot-scope="scope">
            {{ scope.row.card_name
            }}{{ scope.row.soure_type === 2 ? "(赠卡)" : "" }}
          </template>
        </el-table-column>
        <el-table-column label="洗美卡编号" max-width="90">
          <template slot-scope="scope">
            {{ scope.row.card_number }}
          </template>
        </el-table-column>
        <el-table-column label="分类" min-width="60">
          <template slot-scope="scope">
            {{ scope.row.card_category.name }}
          </template>
        </el-table-column>
        <el-table-column label="适用宠物" width="70">
          <template slot-scope="scope">
            <div v-if="scope.row.apply_type === 0">通用</div>
            <div v-if="scope.row.apply_type === 1">猫</div>
            <div v-if="scope.row.apply_type === 2">犬</div>
          </template>
        </el-table-column>
        <el-table-column label="可用服务">
          <template slot-scope="scope">
            {{ scope.row.service_name }}-{{ scope.row.service_object_name }}
          </template>
        </el-table-column>
        <el-table-column label="有效期至" width="135">
          <template slot-scope="scope">
            {{ $public.FTime(scope.row.end_date, "YYYY-MM-DD HH:mm:ss") }}
          </template>
        </el-table-column>
        <el-table-column label="适用体重" min-width="90">
          <template slot-scope="scope">
            {{
              scope.row.enable_weight_limit === 1
                ? scope.row.weight_min + "kg - " + scope.row.weight_max + "kg"
                : "不限体重"
            }}
          </template>
        </el-table-column>
        <el-table-column label="剩余/总次数" width="85">
          <template slot-scope="scope">
            {{ scope.row.surplus_count }}/{{ scope.row.total_count }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="140">
          <template slot-scope="scope">
            <el-button type="text" @click="seePet(scope.row)">查看</el-button>
            <el-button
              v-if="scope.row.soure_type !== 2"
              type="text"
              @click="updatePet(scope.row)"
              >升级</el-button
            >
            <el-button
              v-if="scope.row.soure_type !== 2&&$buttonAuthority('mendian-deletePet')"
              type="text"
              @click="deletePet(scope.row)"
              >退卡</el-button
            >
          </template>
        </el-table-column>
        <span slot="empty">
          <img
            src="../../../../assets/img/konging.png"
            style="width: 340px; margin-top: 100px"
          />
          <div style="font-size: 14px; color: #666; margin: 20px">
            这个人什么痕迹都没留下
          </div>
        </span>
      </el-table>
    </div>
    <div class="pageLine">
      <page
        :page="page.page"
        :pageSize="page.pageSize"
        :total="page.total"
        @change="changePage"
      ></page>
    </div>
    <xizaokaSee
      v-if="drawerJiyangPetSee_state"
      :curItem="curItem"
      @submit="submit_drawerJiyangPetSee"
    ></xizaokaSee>
    <xizaokaRefund
      v-if="drawerJiyangPetRefund_state"
      :curItem="curItem"
      @submit="submit_drawerJiyangPetRefund"
    ></xizaokaRefund>
    <!-- 结算 -->
    <!-- <div v-if="dialogSettlement_state">
			<dialogSettlement :type="'returnGoods'" :orderId="curOrder._id" @submit="submit_dialogSettlement"></dialogSettlement>
		</div> -->
  </div>
</template>
<script>
import page from "../../../../components/page.vue";
import xizaokaSee from "../drawer/xizaokaSee.vue";
import xizaokaRefund from "../drawer/xizaokaRefund.vue";
// import dialogSettlement from "../../../../components/dialog_settlement.vue"
export default {
  components: { page, xizaokaSee, xizaokaRefund },
  data() {
    return {
      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      tableData: [],
      // see
      drawerJiyangPetSee_state: false,
      // delete
      drawerJiyangPetRefund_state: false,
      curItem: {},
      // 结算
      // dialogSettlement_state:false,
      curOrder: {},
    };
  },
  computed: {
    userInfo() {
      if (this.$store.state.mendian.userInfo._id) {
        return this.$store.state.mendian.userInfo;
      } else {
        return {
          basic_info: {},
          card_info: {},
          company_info: {},
          operation_info: {},
          pets_info: [],
          club_card: {},
        };
      }
    },
    curPetId() {
      return this.$store.state.mendian.curPetId;
    },
    curPetInfo() {
      return this.$store.getters["mendian/curPetInfo"];
    },
  },
  watch: {
    curPetInfo() {
      this.getTableData();
    },
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    // 添加
    add() {
      this.$store.commit("xizaoka/set_type", "add");
    },
    // 查看
    seePet(row) {
      console.log(row);
      this.drawerJiyangPetSee_state = true;
      this.curItem = row;
    },
    submit_drawerJiyangPetSee() {
      this.drawerJiyangPetSee_state = false;
    },
    // 升级
    updatePet(row) {
      this.$store.commit("xizaoka/set_curRow", row);
      this.$store.commit("xizaoka/set_type", "update");
    },
    // 删除
    deletePet(row) {
      this.curItem = row;
      this.drawerJiyangPetRefund_state = true;
    },
    submit_drawerJiyangPetRefund() {
      this.drawerJiyangPetRefund_state = false;
      this.$forceUpdate();
      // if(obj.type==='success'){
      // 	this.curOrder = obj.order;
      // 	this.dialogSettlement_state = true;
      // }
    },
    // submit_dialogSettlement(a){
    // 	this.dialogSettlement_state = false;
    // 	if(a=='cancel'){
    // 		console.log(a)
    // 	}else if(a=='fail'){
    // 		this.$message({
    // 			message: '结算失败',
    // 			type: 'error'
    // 		});
    // 	}else if(a=='success'){
    // 		this.$message({
    // 			message: '结算成功',
    // 			type: 'success'
    // 		});
    // 		this.$store.dispatch("mendian/getUserInfo",this.userInfo._id)
    // 		this.$store.commit('mendian/set_cardCount',{card_count:this.cardCount.card_count+1, coupon_count:this.cardCount.coupon_count})
    // 		this.page.page = 1;
    // 		this.getTableData();
    // 	}
    // },
    changePage(num) {
      this.page.page = num;
      this.getTableData();
    },
    // 获取列表
    getTableData() {
      let params = {
        memberId: this.userInfo._id,
        isvalid: 1, // 是否有效 0：不限、1：有效、2：无效
      };
      let loading = this.$loading();
      this.$http.get("/api/Member/BindCards", params).then((res) => {
        loading.close();
        if (res.code == 0) {
          this.tableData = res.data;
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.panel_shouyin {
  height: 100%;
  background-color: #fff;
  padding: 46px 0 0;
  box-sizing: border-box;
  position: relative;
  .titleLine {
    width: 100%;
    background-color: #fff;
    padding: 10px 8px 12px;
    box-sizing: border-box;
    position: absolute;
    top: 0;
  }
  .listLine {
    height: 800px;
    padding: 0 0px 60px 0px;
    box-sizing: border-box;
  }
  .pageLine {
    position: absolute;
    bottom: 0;
    z-index: 1;
    width: 100%;
    padding: 10px;
    background-color: #fff;
    box-sizing: border-box;
  }
}
</style>
